/*
 * The frame URL for an embedded Guide surface.
 *
 * Guide serves two surfaces from one build (apps/guide/src/main.tsx): the embedded chat panel,
 * chosen by `?embed=1` inside a frame, and a development shell with a fictional estate for
 * everything else. A host that frames Guide must reach the first one, so the frame src has to
 * carry `embed` with the exact value `1`.
 *
 * The naive `${url.replace(/\/$/, '')}/?embed=1` breaks the moment the configured
 * `stackschematic.guide.url` already carries that query — `.../guide/?embed=1` becomes
 * `.../guide/?embed=1/?embed=1`, whose `embed` parameter parses to `1/?embed=1`, not `1`. The
 * frame then falls through to the fictional shell, which is exactly what shipped to production.
 *
 * Building the URL through the URL API makes it idempotent: `searchParams.set` replaces any
 * existing value rather than appending a second one, so the helper is correct whether or not the
 * configured URL already names the parameter. The path keeps a trailing slash so nginx serves the
 * SPA rather than redirecting. Returns null for an absent or unparseable URL, matching the
 * callers' existing guards.
 */
export function guideFrameSrc(guideUrl: string | undefined): string | null {
  if (!guideUrl) return null;
  try {
    const url = new URL(guideUrl);
    if (!url.pathname.endsWith('/')) url.pathname += '/';
    url.searchParams.set('embed', '1');
    return url.toString();
  } catch {
    return null;
  }
}
